class BreakpointUtil {
  private static match(breakpoint: string) {
    return window.matchMedia(`screen and (min-width: ${breakpoint})`).matches;
  }

  public static get xs() {
    return this.match('30em');
  }

  public static get sm() {
    return this.match('48em');
  }

  public static get md() {
    return this.match('62em');
  }

  public static get lg() {
    return this.match('75em');
  }
}

export { BreakpointUtil };
